'use strict';
// 1. Отримуємо всі inputs з усіх форм на сторінці
var inputs = document.querySelectorAll('form input');
inputs.forEach(function(input) {
    // Пропускаємо кнопки, якщо вони є інпутами (наприклад, type="submit")
    if (input.type === 'submit' || input.type === 'button') return;
    var inputName = input.name;
    var inputId = input.id;
    // 2. Створюємо елемент label
    var label = document.createElement('label');
    // Додаємо клас та атрибут for для зв'язку з інпутом
    label.classList.add('field-label');
    label.setAttribute('for', inputId);
    // Встановлюємо текст для мітки на основі імені інпута (у верхньому регістрі)
    label.textContent = inputName.toUpperCase();
    // 3. Встановлюємо placeholder з великої літери
    var firstLetter = inputName.charAt(0).toUpperCase();
    var restOfName = inputName.slice(1).toLowerCase();
    input.placeholder = "".concat(firstLetter).concat(restOfName);
    // 4. Додаємо label до батьківського контейнера саме перед інпутом
    // Це важливо, щоб у структурі label був над полем введення
    input.parentElement.insertBefore(label, input);
});

//# sourceMappingURL=js_task_fix_form_DOM.4336fbea.js.map
